import React from 'react';

/**
 *
 * @param {{content: string | null} & React.ComponentPropsWithoutRef<'div'>} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function RawContent(_ref) {
  let {
    content,
    ...props
  } = _ref;
  if (!content) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    dangerouslySetInnerHTML: {
      __html: content
    },
    ...props
  });
}